// extracted by mini-css-extract-plugin
export var arrows = "_78-6";
export var decrementer = "_78-a";
export var disabled = "_78-4";
export var error = "_78-1";
export var hiddenText = "_78-b";
export var incrementer = "_78-9";
export var input = "_78-8";
export var inputWrapper = "_78-0";
export var leadingIcon = "_78-c";
export var readonly = "_78-3";
export var regular = "_78-7";
export var small = "_78-5";
export var warning = "_78-2";